import { block } from 'bem-cn'
import React, { Component } from 'react'
import EmptyCalendar from '../EmptyCalendar'
import Month from '../Month'
import Sidebar from '../Sidebar'
import InfoTooltip from '../../../Components/InfoTooltip'
import { TOOLTIP_STATES, MONTHS } from '../../constants'
import i18n from 'i18next'
import { withI18n } from 'react-i18next'

const b = block('Calendar')

const tooltipsText = {
    [TOOLTIP_STATES.SELECT_CALENDARS]: i18n.t('calendar:tooltips.Please select the calendars'),
    [TOOLTIP_STATES.SWITCH_ON_OFF]: i18n.t('calendar:tooltips.Feel free to switch on/off the calendars'),
    [TOOLTIP_STATES.MOVE]: i18n.t('calendar:tooltips.Feel free to drag-and-drop the tasks'),
    [TOOLTIP_STATES.RESIZE]: i18n.t('calendar:tooltips.Feel free to change duration'),
}

class Calendar extends Component {
    getVisibleTasks(tasks, calendars) {
        const activeCalendarsIds = calendars.filter(c => c.enabled).map(c => c.id)
        return tasks.filter(t => activeCalendarsIds.indexOf(t.calendar) > -1)
    }

    getColorsMap(calendars) {
        const map = {}

        calendars.forEach(c => {
            map[c.id] = c.color
        })

        return map
    }

    render() {
        const { tasks, currentTask, calendars, tooltip, t } = this.props
        const date = new Date()
        const activeTasks = this.getVisibleTasks(tasks, calendars)
        return (
            <div className={b()}>
                <InfoTooltip text={tooltip === 'none' ? null : tooltipsText[tooltip]} />
                <div className={b('header')}>
                    <div className={b('title')}>
                        {t(`calendar:months.${MONTHS[date.getMonth()]}`)} {date.getFullYear()}

                        <span className={b('title-icon')}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5">
                                <path fill="#000" fillOpacity=".9" fillRule="evenodd" d="M0 0h7L3.5 5z"/>
                            </svg>
                        </span>
                    </div>
                </div>

                <div className={b('body')}>
                    <div className={b('sidebar')}>
                        <Sidebar calendars={calendars} />
                    </div>
                    <div className={b('calendar')}>
                        {activeTasks.length > 0 ? (
                            <Month
                                tasks={activeTasks}
                                month={date.getMonth()}
                                year={date.getFullYear()}
                                currentTask={currentTask}
                                colors={this.getColorsMap(calendars)}
                            />
                        ) : (
                            <EmptyCalendar />
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default withI18n()(Calendar)
